export default __webpack_public_path__ + "static/media/Venkateswara (PMR).5f8601c5.png";